module.exports = __webpack_public_path__ + "static/media/clock-regular.f061946e.svg";